import { settings, } from '../types'

const initState = {
  data: null,
  error: null,
  loading: false,
}

export default function settingsReducer (state = initState, action) {
  switch (action.type) {
    
    case settings.UPDATE_SETTINGS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        data: null
      }
    
    case settings.UPDATE_SETTINGS_PENDING:
      return {
        ...state,
        loading: true,
      }
    
    case settings.UPDATE_SETTINGS_SUCCESS:
      return {
        ...state,
        data: true,
        loading: false,
        error: null,
      }

    default:
      return state
  }
}
